import { Outlet } from 'react-router-dom';

import { App, ThemeViewport } from '@ingrid/luterkort-react';

import { AppMerchant } from './app-merchant';
import { AppSwitcher } from './app-switcher';
import { AppTopBar } from './app-top-bar';
import { NavigationMenu } from './nav-menu';

export function AppLayout() {
  return (
    <App.Root>
      <App.LeftPane>
        <App.Logo>
          <AppMerchant />
          <AppSwitcher />
        </App.Logo>

        <NavigationMenu />
      </App.LeftPane>

      <App.CenterPane>
        <ThemeViewport />
        <AppTopBar />

        <App.MainContent>
          <Outlet />
        </App.MainContent>
      </App.CenterPane>
    </App.Root>
  );
}
